<nz-modal [nzVisible]="isModalVisible()" (nzOnCancel)="onCloseModal()" (nzOnOk)="onCloseModal()" nzWidth="700">
  <ng-container *nzModalContent>
    <div class="content">
      <div nz-row nzJustify="center" class="margin-bottom-1 margin-top-small">
        <company-logo-svg style="width: 200px;"></company-logo-svg>
      </div>
      <br>
      <ng-container *ngFor="let markup of splashMarkups">
        <hr>
        <div [innerHTML]="markup | sanitizer: 'html'"></div>
      </ng-container>
    </div>

  </ng-container>

  <div *nzModalFooter>
    <label nz-checkbox nzValue="true" [(ngModel)]="isDontShowMsgAgainChb" id="modal_dont_show_again_chb"
           class="margin-right-1">
      Don't show this message again
    </label>
    <button id="external-popup-ok-btn" class="primary-button" nz-button nzType="primary" (click)="onCloseModal()">OK</button>
  </div>

</nz-modal>
